import React from 'react';
import {geolocated, geoPropTypes} from "react-geolocated";
import ReactTooltip from 'react-tooltip';
import Accordion from 'react-bootstrap/Accordion';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import CircularProgress from '@material-ui/core/CircularProgress';
import allLocales from '@fullcalendar/core/locales-all';

import {Alert} from "react-bootstrap";
import i18n from 'i18next';

import {useTranslation, Trans, withTranslation} from 'react-i18next';

import interactionPlugin from '@fullcalendar/interaction';

import { IoIosArrowUp } from 'react-icons/io';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';

import FlighFrom from "./FlighFrom";
import API from '../api/api';
import TravelItem from '../components/TravelItem';
import TravelDetailPanel from '../components/TravelDetailPanel';
import TravelListToolbar from '../components/TravelListToolbar';
import LanguageSwitcher from '../components/LanguageSwitcher';
import FilterLine from '../components/FilterLine';
import SiteFooter from '../components/SiteFooter';
import './First.css';
import '../App.css';

import querystring from 'querystring';
import moment from 'moment';
import FilterWrap from './FilterWrap';
import { DateTime } from 'luxon';
import { fullCalendarLocale, luxonLocale, fullCalendarDirection } from '../localeUi.js';
import { SUPPORTED_LNGS } from '../supportedLngs.js';
import { setVisitorGeo, setVisitorLang, setVisitorOriginIata } from '../visitorContext.js';
import { trackEvent } from '../analytics.js';
import { travelCityLabel } from '../utils/travelDisplay.js';

const t = i18n.t;

const SITE_ORIGIN = 'https://gdetotam.org';

/** List row id — must stay the same across refetches or React remounts TravelItem and accordion state resets. */
function makeStableTravelId(item) {
  const dep = moment(item.depart_date).format('YYYY-MM-DD');
  const ret = moment(item.return_date).format('YYYY-MM-DD');
  return ['tr', item.origin || '', item.destination || '', dep, ret, String(item.value ?? ''), item.gate || ''].join('|');
}


class AlertDismissible extends React.Component {
  state = {
    show: true
  };

  reset() {
    this.setState({
      show: true
    });
  }

  render() {
    // const {t, i18n} = this.props;

    if (this.state.show) {
      return (
        <Alert className='alert-div' variant={this.props.color} onClose={() => {
          this.setState({show: false});
          this.props.onHide();
        }} dismissible>
          <Alert.Heading>{this.props.errHead}</Alert.Heading>
          <p>
            {this.props.errBody}
          </p>
        </Alert>
      );
    } else {
      return null;
    }
  };
}

class First extends React.Component {
  calRef = React.createRef();
  calendarRef = React.createRef();
  // t = this.props.t;
  // i18n = this.props.i18n;
  // starting = null;
  // startDate = null;

  state = {
    countryName: '',
    countryCode: '',
    city: '',
    apName: '',
    latitude: 0,
    longitude: 0,
    nearby: [],
    searchList: [],
    selected: null,
    fromAirportCode: null,
    fetchTravels: [],
    selectedTravelId: null,
    travelsCalendar: [],
    sortBy: 'date',
    listViewMode: 'grid',
    mobileDetailOpen: false,
    startDate: null,
    minDays: 1,
    maxDays: 15,
    startingMonth: 0,
    fromLabel: null,
    error: null,
    locationDefined: false,
    loading: false
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handeleScroll);
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  }

  isMobileViewport = () => {
    return typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 991.98px)').matches;
  };

  setMobileDetailOpen = (open) => {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = open ? 'hidden' : '';
    }
    this.setState({ mobileDetailOpen: open });
  };

  closeMobileDetail = () => {
    this.setMobileDetailOpen(false);
  };

  componentDidMount() {
    let _this = this;
    const {match: {params}} = this.props;

    if (this.props.match.params) {
      console.log("this.props.match.params = ", params);
    } else {
      console.info("No params arrived");
    }

    window.addEventListener("scroll", this.handeleScroll);
    window.scrollTo(0, 0);

    async function init() {
      return await _this.initLists();
    }

    init().then((res) => {
      console.log("Init func done.");

      const hasAirportInUrl = Boolean(_this.props.match?.params?.source);
      const startupDelayMs = hasAirportInUrl ? 0 : 800;

      setTimeout(async () => {
        try {
          await _this.processParams(res);
          await _this.getLocationDetails();
          await _this.getNearbyAirports(res);
        }
        catch (e) {
          console.error(e);
        }

      }, startupDelayMs);
    });
  }

  componentDidUpdate(prevProps) {
    const c = this.props.coords;
    const pc = prevProps.coords;
    if (
      c &&
      this.props.isGeolocationEnabled &&
      (!pc || c.latitude !== pc.latitude || c.longitude !== pc.longitude)
    ) {
      this.applyBrowserGeolocation(c.latitude, c.longitude);
    }
  }

  initLists = async () => {
    this.setState({
      loading: false
    });
  };

  processParams = async (obj) => {
    try {
      if (!this.props.match.params) {
        return;
      }

      if (this.props.match.params.starting) {
        await this.processStartingParams(this.props.match.params.starting);
      }

      if (this.props.match.params.source) {
        const iata = String(this.props.match.params.source).toUpperCase();
        const input = await API.getBySearch(iata);
        if (input && input.length) {
          await this.processSourceParams(input);
        } else {
          console.warn('getBySearch empty for', iata, '— loading travels by IATA only');
          await this.processSourceParamsFromCode(iata);
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  };

  processStartingParams = async (input) => {
    const starting = moment(input, 'YYYY-MM-DD');

    if (!starting.isValid()) {
      console.log("Input param % is not valid month", input);
      return;
    }

    console.log("Using starting date ", starting);

    let startDate = starting.format('YYYY-MM-DD');
    let startMonth = parseInt(starting.format('MM'), 10);

    this.setState({'startDate': startDate});
    this.setState({'startingMonth': startMonth + 1});
  };

  /** When Travelpayouts autocomplete fails (mobile blockers), still load /from/IATA deals. */
  processSourceParamsFromCode = async (iata) => {
    const inputStr = iata;
    setVisitorOriginIata(iata);
    trackEvent('select_airport', { airport_iata: iata, method: 'url_fallback' });

    this.setState({
      selected: null,
      fromLabel: iata,
      apName: '',
      fromAirportCode: iata,
      loading: false,
      inputStr,
    });

    const airportRec = { code: iata, fromAirportCode: iata, inputStr };
    try {
      await this.onItemClick(airportRec, { method: 'url_fallback' });
    } catch (err) {
      console.error('processSourceParamsFromCode failed:', err);
    }
  };

  processSourceParams = async (selected) => {
    if (!selected || !selected.length) {
      this.setState({
        error: {
          header: t('errors.Selected airport not found'),
          body: t('errors.please select another airport of departure'),
          color: 'warning'
        }
      });

      return;
    }

    this.setState({
      loading: true
    });

    let inStr = this.props.match.params.source;

    // let nearby = await API.nearby(input.latitude, input.longitude, 200);

    let airports = selected.sort((a, b) => {
      if (b.name && !a.name) {
        return 1;
      }
      if (b._type === 'city' && a._type === 'airport') {
        return 1;
      }
      if (a._type === 'city' && b._type === 'airport') {
        return -1;
      }

      return (b._score - a._score);
    });

    const inAirport = selected.find((a) => (a.code === inStr));
    const input = inAirport ? inAirport : airports[0];
    const code = input.code ? input.code : input.city_code;
    const city_name = input.city_name ? input.city_name : input.name;
    const apDisplayName =
      input.name ||
      (input.name_translations && input.name_translations.en) ||
      '';

    console.log("processSourceParams input = ", input);

    let inputStr = `${city_name}, ${input.country_name} (${code})`;

    setVisitorOriginIata(code);
    trackEvent('select_airport', { airport_iata: code, method: 'url' });

    this.setState({
      selected: input,
      fromLabel: inputStr,
      apName: apDisplayName,
      fromAirportCode: code,
      loading: false,
      inputStr: inputStr
    });

    const coords = input.coordinates;
    if (coords && coords.lat != null && coords.lon != null) {
      console.log("Run nearby with coords:", coords.lat, coords.lon);
      API.nearby(coords.lat, coords.lon, 300).then(this.setNearbyAirports);
    }

    const airportRec = {
      code,
      fromAirportCode: code,
      inputStr,
      fromLabel: inputStr,
      apName: apDisplayName,
      coordinates: input.coordinates,
    };

    let _this = this;

    this.onItemClick(airportRec, { method: 'url' }).then(() => {
      try {
        _this.calRef.current.scrollIntoView({behavior: 'smooth'});
      }
      catch (err) {
        //
      }
    }).catch((err) => {
      console.error('onItemClick after URL airport failed:', err);
    });
  };

  setNearbyAirports = (list) => {
    console.log("Received nearby: ", list);
    if (!list || !list.length) {
      return;
    }
    this.setState({
      nearby: list
    });
  };

  getNearbyAirports = async (obj) => {
    // console.log("getNearbyAirports: ", this.state.latitude, this.state.longitude);
    let nearby = [];

    if (!this.state.locationDefined) {
      console.log("getNearbyAirports: No location available.");
    } else {
      nearby = await API.nearby(this.state.latitude, this.state.longitude, 200);
      console.log("getNearbyAirports loade nearby!");
    }

    this.setNearbyAirports(nearby || []);
  };

  handleChangeMinDays = (event) => {
    let fieldName = event.target.name;
    let fleldVal = event.target.value;
    console.log("handleChangeMinDays returned: ", fieldName, fleldVal);
    this.setState({'minDays': fleldVal});
  };

  handleChangeMaxDays = (event) => {
    let fieldName = event.target.name;
    let fleldVal = event.target.value;
    console.log("handleChangeMaxDays returned: ", fieldName, fleldVal);
    this.setState({'maxDays': fleldVal});
  };

  handleChangeStartingMonth = (event) => {
    // let fieldName = event.target.name;
    let fleldVal = event.target.value;

    let startDate = moment().add(fleldVal, 'M').format('YYYY-MM-DD');
    console.log("handleChangeStartingMonth returned: ", fleldVal, startDate);

    this.setState({'startDate': startDate});
    this.setState({'startingMonth': fleldVal});
  };

  updNearBy = async (code) => {
    // const {t, i18n} = this.props;
    let list = await API.getAutoComplete(code);

    if (!list || !list.length) {
      console.log("Invalid code data:", code);

      this.setState({
        error: {
          header: t('errors.Invalid airport of origin : ') + code,
          body: t('errors.please select another airport of departure'),
          color: 'warning'
        }
      });
      return '';
    }

    if (list.length > 1) {
      console.log("The list is too big:", list);
      return '';
    }

    const input = list[0];

    if (!input.hasOwnProperty('coordinates')) {
      console.log("No coordinates available.");
      return '';
    }

    let nearby = await API.nearby(input.coordinates.lat, input.coordinates.lon, 200);
    this.setNearbyAirports(nearby || []);

    return input.name;
  };

  parseInput = (str) => {
    // ${option.name}, ${option.country_name} (${option.code})
    console.log("Received str = ", str);

    if (typeof str === 'object' && str !== null) {
      const code = str.code || str.iata || str.fromAirportCode || str.city_code;
      if (!code) {
        return null;
      }
      return {
        code,
        fromAirportCode: code,
        fromLabel: str.fromLabel || str.inputStr,
        apName: str.apName || str.name,
        inputStr: str.inputStr,
        coordinates: str.coordinates,
      };
    }

    let code = str.match(/(.*?), (.*?) \((.*)\)/);

    if (code && code.length) {
      console.log("Set fromAirportCode to ", code);

      let name = code[1];
      let desc = code[2];
      // let country = code[3];
      let iata = code[3];

      if (iata) {
        const rec = {
          fromAirportCode: iata,
          code: iata,
          fromLabel: desc,
          apName: name,
          inputStr: str
        };

        this.setState(rec);

        this.onItemClick(rec).then(() => {
          console.log("Updated search.");
        });

        return rec;
      }
    }

    return null;
  };

  onAirportUpdate = async (str) => {
    if (str === null || str === undefined || str === '') {
      return;
    }

    if (str.length < 2) {
      return;
    }

    console.log("onAirportUpdate:", str);
    if (this.parseInput(str)) {
      return;
    }

    let result = await API.getAutoComplete(str);
    this.setState({
      searchList: result
    });
  };

  makeTraveLUrl = (travel) => {

    let oprions = {
      origin_iata: this.state.fromAirportCode,
      destination_iata: travel.destination,
      depart_date: travel.depart_date,
      return_date: travel.return_date,
      oneway: 0,
      adults: 1,
      children: 0,
      infants: 0,
      trip_class: 0,
      marker: 20331,
      with_request: true,
      currency: 'usd',
      locale: i18n.language //'en'
    };

    let generated = querystring.stringify(oprions);

    // const URL = `http://hydra.aviasales.ru/searches/new?${generated}`;
    return `http://travel.gdetotam.org/searches/new?${generated}`;
  };

  travelSelected = (travel) => {
    trackEvent('book_click', {
      origin_iata: this.state.fromAirportCode,
      destination_iata: travel.destination,
      price: travel.value,
      depart_date: travel.depart_date,
    });
    window.open(this.makeTraveLUrl(travel), "_blank");
  };

  travelActivate = (travel) => {
    if (!travel) {
      return;
    }
    const isNew = this.state.selectedTravelId !== travel.id;
    if (isNew) {
      trackEvent('show_details', {
        destination_iata: travel.destination,
        price: travel.value,
      });
    }
    const isMobile = this.isMobileViewport();
    if (typeof document !== 'undefined') {
      document.body.style.overflow = isMobile ? 'hidden' : '';
    }
    this.setState({
      selectedTravelId: travel.id,
      mobileDetailOpen: isMobile,
    });
  };

  onCalendarClick = async (info) => {
    const travel = info.event.extendedProps.travel;
    this.travelActivate(travel);
    if (!this.isMobileViewport()) {
      document.getElementById('travels-detail-panel')?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };

  onItemClick = async (item, meta = {}) => {
    if (!item) {
      console.log("Item not defined!!!");
      return;
    }

    console.log("onItemClick Input = ", item);

    const input = this.parseInput(item);

    if (!input) {
      this.setState({
        error: {
          header: 'Airport code is invalid',
          body: 'Please select another airport of departure',
          color: 'warning'
        }
      });

      this.setState({
        fetchTravels: [],
        selectedTravelId: null,
        travelsCalendar: []
        // nearby: [],
      });

      return;
    }

    const fromAirportCode = input.code || input.fromAirportCode || input.iata;
    if (!fromAirportCode) {
      return;
    }
    const lngPrefix = this.props.match?.params?.lng && SUPPORTED_LNGS.includes(this.props.match.params.lng)
      ? `/${this.props.match.params.lng}`
      : '';

    setVisitorOriginIata(fromAirportCode);
    trackEvent('select_airport', {
      airport_iata: fromAirportCode,
      method: meta.method || 'search',
    });

    this.setState({
      error: null,
      fromAirportCode: fromAirportCode
    });

    if (this.state.startDate) {
      this.props.history.push(`${lngPrefix}/from/${fromAirportCode}/since/${this.state.startDate}`);
    } else {
      this.props.history.push(`${lngPrefix}/from/${fromAirportCode}`);
    }

    this.setState({
      loading: true
    });

    const options = {
      fromAirportCode: fromAirportCode,
      startDate: this.state.startDate,
      minDays: this.state.minDays,
      maxDays: this.state.maxDays
    };

    let myJson;
    try {
      myJson = await API.fetchTravels(options);
    } catch (fetchErr) {
      console.error('fetchTravels failed:', fetchErr);
      this.setState({
        error: {
          header: 'Connection error',
          body: 'Could not load deals. If you are on a restricted network, try another connection or browser.',
          color: 'danger',
        },
        loading: false,
      });
      return;
    }

    if (!myJson || !myJson.success) {
      let errMsg = 'Server returned the error, possibly issue with firewall?';

      if (myJson.error) {
        if (myJson.error.includes('Unknown place iata')) {
          errMsg = "Invalid airport : " + this.state.fromAirportCode;
          this.setState({
            error: {
              header: 'Airport data not valid',
              body: errMsg,
              color: 'warning'
            },
            fetchTravels: [],
            selectedTravelId: null,
            travelsCalendar: [],
            // nearby: [],
            loading: false
          });

          return;
        }
      }

      // other error treatment:
      console.log("Error returned", JSON.stringify(myJson, null, 2));

      this.setState({
        error: {
          header: 'Server error',
          body: errMsg,
          color: 'danger'
        },
        fetchTravels: [],
        selectedTravelId: null,
        // nearby: [],
        travelsCalendar: [],
        loading: false
      });

      return;
    }

    if (!myJson.data || !myJson.data.length) {
      console.log("Empty travels returned", JSON.stringify(myJson, null, 2));
      trackEvent('search_travels', { airport_iata: fromAirportCode, result_count: 0 });
      this.setState({
        error: {
          header: 'No travels found',
          body: 'Sorry, we didn\'t find any travel for you, please try different airport or adjust a filter',
          color: 'info'
        },
        fetchTravels: [],
        selectedTravelId: null,
        // nearby: [],
        travelsCalendar: [],
        loading: false
      });

      return;
    }

    let items;
    try {
      const anAsyncFunction = async (item) => {
        item.id = makeStableTravelId(item);
        item.ref = React.createRef();
        return item;
      };

      items = await Promise.all(myJson.data.map(async (item) => anAsyncFunction(item)));

      items = items.sort((a, b) => {
        return new Date(a.depart_date) - new Date(b.depart_date);
      }).filter((a) => {
        return a.value <= 200;
      });
    } catch (processErr) {
      console.error('Processing travels failed:', processErr);
      this.setState({
        error: {
          header: 'Could not show deals',
          body: 'The server returned data in an unexpected format. Try a hard refresh (Ctrl+Shift+R).',
          color: 'danger',
        },
        loading: false,
      });
      return;
    }

    let travelsCalendar = items.map(travel => {
      if (!travel.city) {
        return null;
      }

      const city = travelCityLabel(travel);
      const country = travel.country || '';

      return {
        id: travel.id,
        title: `${city}, ${country} $${travel.value}`,
        start: travel.depart_date,
        end: travel.return_date,
        className: 'bg-success text-white text-center',
        travel: travel
      };
    }).filter(c => c);

    trackEvent('search_travels', { airport_iata: fromAirportCode, result_count: items.length });

    this.setState({
      fetchTravels: items,
      selectedTravelId: items[0]?.id ?? null,
      travelsCalendar: travelsCalendar,
      loading: false,
    }, () => {
      this.calRef.current?.scrollIntoView({ behavior: 'smooth' });
      const calendarApi = this.calendarRef.current?.getApi?.();
      const firstDate = items[0]?.depart_date;
      if (calendarApi && firstDate) {
        calendarApi.gotoDate(firstDate);
      }
    });
  };

  handleSubmit(event) {
    console.log("Submit button pressed.");
    event.preventDefault();
    return false;
  }

  applyBrowserGeolocation = (latitude, longitude) => {
    console.log("applyBrowserGeolocation", latitude, longitude);
    this.setState({
      latitude,
      longitude,
      locationDefined: true,
    }, () => {
      API.nearby(latitude, longitude, 200).then(this.setNearbyAirports);
    });
  };

  defineCurrentLocation = async (latitude, longitude) => {
    this.applyBrowserGeolocation(latitude, longitude);
  };

  getLocationDetails = async () => {
    if (this.props.coords && this.props.isGeolocationEnabled) {
      this.applyBrowserGeolocation(
        this.props.coords.latitude,
        this.props.coords.longitude
      );
      return;
    }

    if (!this.props.isGeolocationAvailable) {
      console.log("getLocationDetails: geolocation not available");
    } else if (this.props.isGeolocationDenied) {
      console.log("getLocationDetails: geolocation denied");
    } else if (!this.props.coords) {
      console.log("getLocationDetails: waiting for coords (common on mobile)");
    }

    const geo = await API.clientGeoIp();
    console.log("Server GeoIP fallback:", geo);
    setVisitorGeo(geo);
  };

  eventMouseEnter(info) {
    // console.log("Show tooltip : ", info.event.title);
    // info.el.setAttribute("data-tip", info.event.title);
    //
    // ReactTooltip.rebuild();
  }

  handeleScroll() {
    const topBtn = document.getElementById("topBtn");
    if (!topBtn) {
      return;
    }
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      topBtn.style.display = "block";
    } else {
      topBtn.style.display = "none";
    }
  }

  topFunction() {
    console.log("Scroll to top");
    // window.scrollTo(0,0);
    window.scrollTo({top: 0, behavior: "smooth"});
  }

  setSortBy = (flag) => {
    console.log("SortBy:", flag);
    this.setState({'sortBy': flag});
  };

  setListViewMode = (mode) => {
    const next = mode === 'list' ? 'grid' : mode;
    if (next === this.state.listViewMode) {
      return;
    }
    this.setState({ listViewMode: next });
  };

  onStartMonth = (num) => {
    console.log("start month offset = ", num);
    this.setState({'startDate': moment().add(num, 'M').format('YYYY-MM-DD')});
  };

  makeStructuredJson = (travels) => {
    if (!travels || !travels.length) {
      return null;
    }

    let startUrl = `https://gdetotam.org/from/${this.state.fromAirportCode}`;

    if (this.state.startDate) {
      startUrl = startUrl + '/since/' + this.state.startDate;
    }

    const titleHdr = t("siteHeadline");
    // const title = `${titleHdr} from ${lbl}`;

    let dataHeader = {
      "@context": "http://schema.org/",
      "@graph": []
    };

    dataHeader["@graph"] = (travels || []).map((tr) => {
      const url = this.makeTraveLUrl(tr);
      const title = `Flight from ${this.state.fromLabel} at ${tr.depart_date} to ${tr.city.name_translations.en},${tr.country} for ${tr.days} days.`;
      const desc = `${titleHdr}: flight from ${this.state.fromLabel} at ${tr.depart_date} to ${tr.country} for ${tr.days} days.`;

      // console.log("processing travel:", tr);

      return {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        "@id": tr.id,
        "name": title,
        "description": title,
        "arrivalTime": tr.depart_date,
        "departureTime": tr.return_date,
        "image": tr.image_big,
        "touristType": [
          "Cultural tourism",
          "Urban tourism",
          "Nightlife tourism",
          "Shopping tourism"
        ],
        "subjectOf": {
          "@type": "CreativeWork",
          "name": desc,
          "url": startUrl
        },
        "itinerary": [{
          "@type": "City",
          "name": tr.city.name_translations.en,
          "url": `https://gdetotam.org/from/${tr.airport.code}`
        }],
        "offers": {
          "@type": "Offer",
          "name": title,
          "description": desc,
          "price": tr.value,
          "priceCurrency": "USD",
          "url": url,
          "eligibleRegion": {
            "@type": "Country",
            "name": tr.country
          }
        }
      };
    });

    return JSON.stringify(dataHeader, null, 2);
  };

  handleEventPositioned(info) {
    // console.log("handleEventPositioned tooltip : ", info.event);
    let days = moment(info.event.end).diff(moment(info.event.start), 'days');
    info.el.setAttribute("data-tip", info.event.title + ', ' + days + ' days');
    ReactTooltip.rebuild();
  }

  render() {
    const lng = this.props.match?.params?.lng && SUPPORTED_LNGS.includes(this.props.match.params.lng)
      ? this.props.match.params.lng
      : null;
    const lngPrefix = lng ? `/${lng}` : '';

    let travelsSorted = this.state.fetchTravels.sort((a, b) => {
      if (this.state.sortBy === 'date') {
        return new Date(a.depart_date) - new Date(b.depart_date);
      } else {
        return a.value - b.value;
      }
    });

    const selectedTravel = travelsSorted.find((tr) => tr.id === this.state.selectedTravelId) || null;

    const listViewMode = this.state.listViewMode === 'list' ? 'grid' : this.state.listViewMode;

    let TravelList = travelsSorted.map((tr) => (<TravelItem
      travel={tr}
      key={tr.id}
      isSelected={tr.id === this.state.selectedTravelId}
      onActivate={this.travelActivate}
      lngPrefix={lngPrefix}
      viewMode={listViewMode}
    />));

    let airportSeoLead = null;
    if (this.state.fromAirportCode) {
      const sel = this.state.selected;
      if (sel && sel.city_name && sel.country_name) {
        airportSeoLead = (
          <p className="seo-airport-lead">
            {t('seo.airportLandingLead', {
              city: sel.city_name,
              country: sel.country_name,
              airport: sel.name || this.state.apName || '',
              iata: this.state.fromAirportCode,
              headline: t('siteHeadline'),
            })}
          </p>
        );
      } else if (this.state.apName) {
        airportSeoLead = (
          <p className="seo-airport-lead">
            {t('seo.airportLandingFallback', {
              airport: this.state.apName,
              iata: this.state.fromAirportCode,
              headline: t('siteHeadline'),
            })}
          </p>
        );
      }
    }

    let error;
    if (this.state.error) {
      error =
        <AlertDismissible
          errHead={this.state.error.header}
          errBody={this.state.error.body}
          color={this.state.error.color}
          onHide={() => {
            this.setState({error: null});
          }
          }/>;
    }

    let headers;
    let sourceLabel;

    if (this.state.fromLabel) {
      let lbl = this.state.fromLabel;
      const apName = this.state.apName;
      if (apName && !lbl.includes(apName)) {
        lbl = `${lbl} (${apName})`;
      }
      let url = `${SITE_ORIGIN}${lngPrefix}/from/${this.state.fromAirportCode}`;
      const canonicalUrl = `${SITE_ORIGIN}/from/${this.state.fromAirportCode}`;

      if (this.state.startDate) {
        lbl = lbl + ' starting from ' + this.state.startDate;
        url = url + '/since/' + this.state.startDate;
      }

      const titleHdr = t("siteHeadline");
      const title = `${titleHdr} ${t("from")} ${lbl}`;
      const desc = `${title}. ${t("siteSubline")}`;
      const structData = TravelList ? (
        <script className='structured-data-list' type="application/ld+json">
          {this.makeStructuredJson(travelsSorted)}
        </script>) : '';

      sourceLabel = <span className="App-origin-line">{t('from')} {this.state.fromLabel}</span>;

      headers = <Helmet>
        <meta name="description" content={desc}/>
        <meta property="og:title" content={title}/>
        <meta property="og:description" content={desc}/>

        <meta content={title} name="twitter:title"/>
        <meta content={desc} name="twitter:description"/>
        <title>{title}</title>
        <link rel="canonical" href={lng ? url : canonicalUrl}/>

        {SUPPORTED_LNGS.map((altLng) => {
          const altPrefix = `/${altLng}`;
          const altHref = `${SITE_ORIGIN}${altPrefix}/from/${this.state.fromAirportCode}` + (this.state.startDate ? `/since/${this.state.startDate}` : '');
          return <link key={altLng} rel="alternate" hrefLang={altLng} href={altHref}/>;
        })}
        <link rel="alternate" hrefLang="x-default"
              href={`${SITE_ORIGIN}/from/${this.state.fromAirportCode}` + (this.state.startDate ? `/since/${this.state.startDate}` : '')}/>

        <meta name="audience" content="all"/>
        <meta name="HandheldFriendly" content="True"/>
        <meta name="MobileOptimized" content="320"/>

        <meta property="og:site_name" content={titleHdr}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={title}/>
        <meta property="og:description" content={desc}/>

        <meta property="og:url" content={url}/>

        <meta name="abstract" content={desc}/>
        <meta name="page-topic" content={title}/>

        <meta name="twitter:card" content={title}/>
        <meta name="twitter:title" content={title}/>
        <meta name="twitter:description" content={desc}/>
        <meta name="twitter:url" content={url}/>

        {structData}

      </Helmet>;
    }

    let cal;
    const loc = luxonLocale(i18n.language);
    const localStartDate = this.state.startDate
      ? DateTime.fromFormat(this.state.startDate, 'yyyy-MM-dd').setLocale(loc).toFormat('LLLL, yyyy')
      : DateTime.now().setLocale(loc).toFormat('LLLL, yyyy');
    let footerNearby = null;
    if (this.state.nearby && this.state.nearby.length) {
      footerNearby = (
        <>
          <span className="site-footer__nearby-label">{i18n.t('misc.try_different')}</span>
          <div className="site-footer__nearby-links">
            {this.state.nearby.map((ap, index) => (
              <a
                key={'nb-' + index}
                title={t('siteHeadline') + ' ' + t('from') + ` ${ap.name}`}
                href={`${lngPrefix}/from/${ap.iata}`}
                onClick={() => {
                  setVisitorOriginIata(ap.iata);
                  trackEvent('select_airport', { airport_iata: ap.iata, method: 'nearby_link' });
                }}
              >
                {ap.name}
              </a>
            ))}
          </div>
        </>
      );
    }

    const resultsIntroPanel = (sourceLabel || airportSeoLead) ? (
      <aside className="results-header__intro" aria-label={t('siteHeadline')}>
        <h2 className="results-header__headline">{t('siteHeadline')}</h2>
        {sourceLabel}
        {airportSeoLead}
      </aside>
    ) : null;

    if (this.state.travelsCalendar.length) {
      cal =
        <div className="results-header">
          <div className="results-header__calendar">
            <div id="mainCalendar">
              <div ref={this.calRef}/>
              <ReactTooltip/>
              <div className="results-summary text-muted">
                <h3 className="bodySubTitle text-muted text-left">
                  {t('results.foundForMonth', { count: this.state.travelsCalendar.length, month: localStartDate })}
                </h3>
              </div>
              <Accordion defaultActiveKey="mainCalendar">
                <FilterLine onStartMonth={this.onStartMonth}/>

                <Accordion.Collapse eventKey="mainCalendar">
              <div id="calendarId" className="main-calendar-host">
                <FullCalendar
                  initialView="dayGridMonth"
                  locales={allLocales}
                  locale={fullCalendarLocale(i18n.language)}
                  direction={fullCalendarDirection(i18n.language)}
                  plugins={[dayGridPlugin, interactionPlugin]}
                  weekends={true}
                  events={this.state.travelsCalendar}
                  eventMouseEnter={this.eventMouseEnter}
                  height="auto"
                  fixedWeekCount={false}
                  initialDate={this.state.fetchTravels[0]?.depart_date}
                  eventDidMount={this.handleEventPositioned}
                  id="big-calendar"
                  ref={this.calendarRef}
                  eventClick={this.onCalendarClick}/>
              </div>
                </Accordion.Collapse>
              </Accordion>
            </div>
          </div>
          {resultsIntroPanel}
        </div>;
    }

    return (
      <div className="App">
        {headers}
        <header className="App-header">
          <LanguageSwitcher />
          <div className="container text-center">
            <div className='App-logo'>{t("siteHeadline")}</div>
            {sourceLabel}
            <FlighFrom
              searchList={this.state.searchList}
              nearby={this.state.nearby}
              label={this.state.inputStr ? this.state.inputStr : 'Flying from?'}
              onItemClick={this.onItemClick}
              update={this.onAirportUpdate}
              input={this.state.inputStr}
              location={this.props.coords}/>
            <FilterWrap
              handleChangeMinDays={this.handleChangeMinDays}
              MinDays={this.state.minDays}
              handleChangeMaxDays={this.handleChangeMaxDays}
              MaxDays={this.state.maxDays}
              handleChangeStartingMonth={this.handleChangeStartingMonth}
              StartingMonth={this.state.startingMonth}
            />
            {error}
            {this.state.loading && <CircularProgress/>}
          </div>
        </header>

        {!cal && (sourceLabel || airportSeoLead) && (
          <div className="bodyTitle">
            <div className="bodyTitle-head">{t("siteHeadline")}</div>
            {sourceLabel}
            {airportSeoLead}
          </div>
        )}

        <div className='travels-found' id='travels'>
          {cal}
          {TravelList.length > 0 && (
            <div className="travels-main">
              <div className={`travels-list travels-list--${listViewMode}`} id="tr-list">
                <TravelListToolbar
                  count={travelsSorted.length}
                  sortBy={this.state.sortBy}
                  viewMode={listViewMode}
                  onSort={this.setSortBy}
                  onViewMode={this.setListViewMode}
                />
                {TravelList}
              </div>
              <div className="travels-detail travels-detail--desktop" id="travels-detail-panel">
                <TravelDetailPanel
                  key={selectedTravel?.id || 'empty'}
                  travel={selectedTravel}
                  onBook={this.travelSelected}
                  lngPrefix={lngPrefix}
                />
              </div>
            </div>
          )}
          {selectedTravel && this.state.mobileDetailOpen && (
            <div className="travel-detail-mobile" id="travel-detail-mobile" role="dialog" aria-modal="true">
              <TravelDetailPanel
                key={'mobile-' + selectedTravel.id}
                travel={selectedTravel}
                onBook={this.travelSelected}
                onBack={this.closeMobileDetail}
                lngPrefix={lngPrefix}
              />
            </div>
          )}
          <button
            onClick={this.topFunction}
            id="topBtn"
            title="Go to top">
            <IoIosArrowUp/>
          </button>
        </div>

        <SiteFooter nearbyLinks={footerNearby} />
      </div>
    );
  }
}


First.propTypes = {
  ...First.propTypes,
  ...geoPropTypes
};

function FirstRoute(props) {
  const params = useParams();
  const navigate = useNavigate();
  const history = { push: (to) => navigate(to) };

  const lng = params?.lng;

  React.useEffect(() => {
    const routeLng = lng && SUPPORTED_LNGS.includes(lng) ? lng : null;
    const active = routeLng || i18n.language || 'en';
    const safe = SUPPORTED_LNGS.includes(active) ? active : 'en';
    if (routeLng) {
      setVisitorLang(routeLng);
    }
    const htmlLang =
      safe === 'zh' ? 'zh-Hans' :
      safe === 'he' ? 'he' :
      safe === 'ja' ? 'ja' :
      safe === 'ar' ? 'ar' :
      safe;
    document.documentElement.lang = htmlLang;
    document.documentElement.dir = safe === 'he' || safe === 'ar' ? 'rtl' : 'ltr';
  }, [lng, i18n.language]);

  if (lng && SUPPORTED_LNGS.includes(lng) && i18n.language !== lng) {
    void i18n.changeLanguage(lng);
  }

  return <First {...props} match={{ params }} history={history} />;
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false,
    maximumAge: 300000,
    timeout: 15000,
  },
  userDecisionTimeout: 15000,
  watchPosition: false,
})(FirstRoute);
